import { render, staticRenderFns } from "./App.vue?vue&type=template&id=62ddf128"
import script from "./services/App.js?vue&type=script&lang=js&external"
export * from "./services/App.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports